export default __webpack_public_path__ + "static/6586-3e313fae1755d7bd2da492ad92f8fa16.jpg";